var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "bg-white py-8 border-b-2 border-gray-300" }, [
      _c(
        "div",
        {
          staticClass: "w-full md:w-10/12 mx-auto flex flex-wrap px-4 md:px-0"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start"
            },
            [
              _c("h2", { staticClass: "font-bold text-2xl" }, [
                _vm._v("Logged Out")
              ]),
              _c("h3", { staticClass: "text-xl text-gray-600 mr-5 mt-5" }, [
                _vm._v("You have been successfully logged out.")
              ]),
              _c(
                "a",
                {
                  staticClass:
                    "bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-2 pl-3 pr-4 border border-blue-400 rounded hover:shadow inline-flex items-center mt-5",
                  attrs: { href: "https:/webpart.store" }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fill-current h-5 w-5 mr-2",
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                        }
                      })
                    ]
                  ),
                  _c("span", [_vm._v("Go to website")])
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }